module.exports = __webpack_public_path__ + "img/37580-056.60fd0990.jpg";